import React from 'react';
import block from 'bem-cn';

import Spinner from 'components/Spinner/view/desktop';
import usePayments from 'features/finance/hooks/usePayments';
import { PAYMENT_STEPS } from 'features/finance/data';

import AmountStep from './steps/AmountStep';
import PurchaseStep from './steps/PurchaseStep';
import WaitingStep from './steps/WaitingStep';
import ResultStep from './steps/ResultStep';

import './Payments.scss';

const b = block('payments');

const Payments = () => {
  const {
    isAllowed,
    isProcessing,
    locale,
    step,
    amount,
    setAmount,
    maxDeposit,
    preorder,
    paymentAmount,
    resultStatus,
    elapsedSeconds,
    timerSeconds,
    handleAmountSubmit,
    handlePurchaseSubmit,
    handleExpire,
    handleRestart,
  } = usePayments();

  if (!isAllowed) return null;

  return (
    <div className={b()}>
      <Spinner isLoading={isProcessing && step === PAYMENT_STEPS.AMOUNT} />
      <div className={b('card', { wide: step === PAYMENT_STEPS.PURCHASE })}>
        {step === PAYMENT_STEPS.AMOUNT && (
          <AmountStep
            amount={amount}
            onAmountChange={setAmount}
            onSubmit={handleAmountSubmit}
            locale={locale}
            maxDeposit={maxDeposit}
            isProcessing={isProcessing}
          />
        )}
        {step === PAYMENT_STEPS.PURCHASE && (
          <PurchaseStep
            amount={paymentAmount}
            walletAddress={preorder?.walletAddress}
            qrUrl={preorder?.walletQrCodeUrl}
            timerSeconds={timerSeconds}
            onSubmit={handlePurchaseSubmit}
            onExpire={handleExpire}
            locale={locale}
            maxDeposit={maxDeposit}
            isProcessing={isProcessing}
          />
        )}
        {step === PAYMENT_STEPS.WAITING && (
          <WaitingStep
            amount={paymentAmount}
            walletAddress={preorder?.walletAddress}
            timerSeconds={timerSeconds}
            locale={locale}
          />
        )}
        {step === PAYMENT_STEPS.RESULT && (
          <ResultStep status={resultStatus} elapsedSeconds={elapsedSeconds} locale={locale} onRestart={handleRestart} />
        )}
      </div>
    </div>
  );
};

export default Payments;
